import { Resource_AppointmentStatus, useGetPortalUserAppointmentsQuery } from '@/generated/graphql';
import { Col, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import moment from 'moment';
import Link from 'next/link';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { getAttendeeStatus, useCurrentUser } from '../../helpers/utils';
import { AppointmentCard } from '../appointment-card';
import styles from './home.module.scss';

export const UpcomingAppointments: FC = () => {
  const { formatMessage } = useIntl();

  const { currentUser } = useCurrentUser();

  const { data: appointmentsData } = useGetPortalUserAppointmentsQuery({
    variables: {
      statusIn: [Resource_AppointmentStatus.AppointmentStatusBooked],
    },
  });

  const proxyAppointments = appointmentsData?.getPortalUserAppointments?.proxyAppointments
    ?.filter((proxyAppointment) => {
      const status = getAttendeeStatus(proxyAppointment?.appointment, currentUser?.id);
      const startTime = proxyAppointment?.appointment?.startTime;

      return (
        status === Resource_AppointmentStatus.AppointmentStatusBooked &&
        startTime?.seconds > moment().unix()
      );
    })
    ?.sort((a, b) => a!.appointment!.startTime!.seconds! - b!.appointment!.startTime!.seconds!);

  return proxyAppointments && proxyAppointments?.length > 0 ? (
    <Space
      style={{ width: '100%' }}
      direction={'vertical'}
      size={8}
      className={styles.upcomingAppointments}
    >
      <Row>
        <Col lg={12} xs={24}>
          <Title level={2}>{formatMessage({ id: 'upcoming-appointments' })}</Title>
        </Col>
        <Col lg={12} xs={0} style={{ textAlign: 'right' }}>
          <Title level={3}>
            <Link href={'/appointments'}>{formatMessage({ id: 'see-all' })}</Link>
          </Title>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        {proxyAppointments?.slice(0, 2)?.map((proxyAppointment) => (
          <Col lg={12} xs={24} key={proxyAppointment?.appointment?.id}>
            <AppointmentCard appointmentProxy={proxyAppointment} />
          </Col>
        ))}
      </Row>
    </Space>
  ) : null;
};
